// import React from 'react';
// import { Navigate } from 'react-router-dom';
//
// const ProtectedRoute = ({ children }) => {
//   const token = localStorage.getItem('accessToken');
//
//   if (!token) {
//       console.log("Navigating to login page due to no token.");
//       return <Navigate to="/" />;
//   }
//
//   return children;
// };
//
//
// export default ProtectedRoute;

// Components/ProtectedRoute.js
import React from 'react';
import {Navigate} from 'react-router-dom';
import superAdminAPI from '../services/superAdminAPI';

const ProtectedRoute = ({children}) => {
    // Check if user is authenticated
    const isAuthenticated = superAdminAPI.isAuthenticated();

    // If not authenticated, redirect to login page
    if (!isAuthenticated) {
        return <Navigate to="/" replace/>;
    }

    // If authenticated, render the protected component
    return children;
};

export default ProtectedRoute;